import { useEffect } from 'react'

const BASE = 'TrackIT'

/**
 * Sets the browser tab title to "<page> · TrackIT" (or just "TrackIT" when no
 * page title is given). Pass a dynamic value (e.g. a project name) and the tab
 * updates as it loads. Restores the base title on unmount.
 */
export function useDocumentTitle(title?: string | null) {
  useEffect(() => {
    document.title = title ? `${title} · ${BASE}` : BASE
    return () => {
      document.title = BASE
    }
  }, [title])
}
